import { PublicProgram } from 'models/program.model'

export const getPublicProgramFragment = (data: PublicProgram[] | null) => {
  if ( !Array.isArray(data) || !data.length ) return 'Without results'
  let bodyFragment = ''
  const baseUrl = 'https://acespacecourts.com'

  data.forEach(
    ({ name, id }: PublicProgram, i: number) => {
      let publicProgramFragment = `<div style="margin: 4px; width: 100%">
                <a href="${baseUrl}/locations/${id}/programs" target="_blank" style="
                font-family: 'Work Sans';
                border-radius: 12px;
                text-align: center;
                padding: 10px 26px;
                margin-top: 10px;
                cursor: pointer;
                font-size: 14px;
                font-weight: 400;
                font-style: normal;
                letter-spacing: -0.5px;
                max-width: max-content;
                line-height: 0.875rem;
                opacity: 1;
                display: flex;
                -webkit-box-align: center;
                align-items: center;
                -webkit-box-pack: center;
                justify-content: center;
                height: 36px;
                border: 2px solid #1600FF;
                box-sizing: border-box;
                background: white;
                color: #1600FF;
                text-decoration-line: blink;
            ">${name}</a>
            </div>`
      if (data.length > 1 && i < data.length) {
        publicProgramFragment += `<hr style="color: gray; margin: 2rem"/>`
      }
      bodyFragment += publicProgramFragment
    }
  )

  return `<div id="programs-container">${bodyFragment}</div>`
}
